import {
  AMAZON_SFP,
  AMAZON_SHIPPER,
  AUSTRALIA_POST,
  CANADA_POST,
  PITNEY_CBDS,
  DHL,
  DHL_ECOMMERCE,
  ENDICIA,
  FEDEX,
  FEDEX_360,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SENDLE,
  SHIPPO,
  UPS,
  USPS_SHIP,
} from '../../../../common/constants/ShipperNames.js'

import AmazonSFPForm from './AmazonSFPForm.js'
import AmazonShipperForm from './AmazonShipperForm.js'
import AustraliaPostForm from './AustraliaPostForm.js'
import CanadaPostForm from './CanadaPostForm.js'
import PitneyCBDSForm from './PitneyCBDSForm.js'
import DHLForm from './DHLForm.js'
import DHLEcommerceForm from './DHLEcommerceForm.js'
import EndiciaForm from './EndiciaForm.js'
import FedExForm from './FedExForm.js'
import FedEx360Form from './FedEx360Form.js'
import NewgisticsForm from './NewgisticsForm.js'
import PitneyForm from './PitneyForm.js'
import PitneyMerchantForm from './PitneyMerchantForm.js'
import PitneyPresortForm from './PitneyPresortForm.js'
import SendleForm from './SendleForm.js'
import ShippoForm from './ShippoForm.js'
import UPSForm from './UPSForm/index.js'
import USPSShipForm from './USPSShipForm.js'

export default {
  [AMAZON_SFP]: AmazonSFPForm,
  [AMAZON_SHIPPER]: AmazonShipperForm,
  [AUSTRALIA_POST]: AustraliaPostForm,
  [CANADA_POST]: CanadaPostForm,
  [PITNEY_CBDS]: PitneyCBDSForm,
  [DHL]: DHLForm,
  [DHL_ECOMMERCE]: DHLEcommerceForm,
  [ENDICIA]: EndiciaForm,
  [FEDEX]: FedExForm,
  [FEDEX_360]: FedEx360Form,
  [NEWGISTICS]: NewgisticsForm,
  [PITNEY]: PitneyForm,
  [PITNEY_MERCHANT]: PitneyMerchantForm,
  [PITNEY_PRESORT]: PitneyPresortForm,
  [SENDLE]: SendleForm,
  [SHIPPO]: ShippoForm,
  [UPS]: UPSForm,
  [USPS_SHIP]: USPSShipForm,
}
